module.exports = __webpack_public_path__ + "img/filter-applied.9a2871ed.svg";